// @mui

import { Box, TableCell, Typography, useTheme } from "@mui/material";
import PercentageChip from "~src/components/PercentageChip";

// utils
// @types
import { getScoreColor } from "~src/utils/scores";

// ----------------------------------------------------------------------

type Props = {
  scoreRanking?: number | null;
  scorePercentage?: number | null;
};

export default function ScoreCell({ scoreRanking, scorePercentage }: Props) {
  const theme = useTheme();

  const showScorePercentage = scorePercentage != null && scorePercentage > 0;

  if (!scoreRanking) {
    return (
      <TableCell>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              width: "49px",
              height: "8px",
              backgroundColor: theme.palette.grey[200],
              mr: 2,
            }}
          >
            <Box
              sx={{
                height: "100%",
                width: `${scoreRanking}%`,
                backgroundColor: getScoreColor(0),
              }}
            />
          </Box>
          <Typography variant="body2">-</Typography>
          {showScorePercentage && (
            <Box sx={{ ml: 2 }}>
              <PercentageChip value={scorePercentage} />
            </Box>
          )}
        </Box>
      </TableCell>
    );
  }

  return (
    <TableCell>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            width: "49px",
            height: "8px",
            backgroundColor: theme.palette.grey[200],
            mr: 2,
          }}
        >
          <Box
            sx={{
              height: "100%",
              width: `${scoreRanking}%`,
              backgroundColor: getScoreColor(scoreRanking),
            }}
          />
        </Box>
        <Typography variant="body2">{scoreRanking}</Typography>
        {showScorePercentage && (
          <Box sx={{ ml: 2 }}>
            <PercentageChip value={scorePercentage} />
          </Box>
        )}
      </Box>
    </TableCell>
  );
}
